module.exports = __webpack_public_path__ + "static/media/Chalet-NewYorkSixty.e164abe4.woff2";